import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBuilding } from "@fortawesome/free-regular-svg-icons"
import { theme } from "../settings/config"
import { lessonsContext } from "../providers/lessons.provider"
import { schoolContext } from "../providers/school.provider"
import Switch from "../atoms/Switch"
import ToggleChip from "../atoms/ToggleChip"
import Divider from "../atoms/Divider"

// Le lezioni degli altri circoli, viste in trasparenza accanto a quelle del
// circolo scelto: si accendono qui, e si sceglie quali circoli lasciare
// fuori. Vale per tutti i circoli — guardando l'uno si vedono le ore
// nell'altro — e, come la vista e il tema, per questo telefono o questo
// computer.
//
// Con un circolo solo non c'è niente da vedere altrove, e la riga non c'è.
function OtherSchoolsSelector() {
	const {
		otherSchoolIDs,
		showOtherSchools,
		hiddenOtherSchools,
		setShowOtherSchools,
		setOtherSchoolHidden,
	} = useContext(lessonsContext)
	const { schools } = useContext(schoolContext)

	// i circoli si conoscono per nome solo dopo averli letti
	const others = otherSchoolIDs.filter(schoolID => schools[schoolID]?.schoolName)
	if (others.length === 0) return null

	return (
		<>
			<Divider w="2px solid" borderColor={theme.colors.background} m={{ y: "1rem" }} />

			<Div
				d="flex"
				align="center"
				justify="space-between"
				cursor="pointer"
				role="switch"
				aria-checked={showOtherSchools}
				aria-label="Mostra le lezioni degli altri circoli"
				style={{ gap: "0.75rem" }}
				onClick={() => setShowOtherSchools(!showOtherSchools)}>
				<Div d="flex" align="center" style={{ gap: "0.75rem", minWidth: 0 }}>
					<Div
						w="40px"
						h="40px"
						rounded="circle"
						bg={showOtherSchools ? theme.colors.primary_light : theme.colors.gray_light}
						d="flex"
						align="center"
						justify="center"
						transition
						style={{ flexShrink: 0 }}>
						<FontAwesomeIcon
							icon={faBuilding}
							color={showOtherSchools ? theme.colors.primary : theme.colors.text_light}
						/>
					</Div>
					<Div style={{ minWidth: 0 }}>
						<Text textWeight="bold" textSize="subheader">
							Altri circoli
						</Text>
						<Text textSize="caption" textColor={theme.colors.text_light}>
							{showOtherSchools
								? "Vedi anche le ore che passi altrove"
								: "Vedi solo le lezioni del circolo scelto"}
						</Text>
					</Div>
				</Div>
				<Switch
					shadow="0"
					checked={showOtherSchools}
					activeColor={theme.colors.gunmetal_fill}
					inactiveColor="gray_light"
					style={{ flexShrink: 0 }}
				/>
			</Div>

			{showOtherSchools && (
				<Div
					m={{ t: "0.75rem" }}
					p="0.75rem"
					rounded="15px"
					bg={theme.colors.background}
					d="flex"
					flexDir="column"
					style={{ gap: "0.6rem" }}>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						Le lezioni che hai in questi circoli compaiono accanto alle altre, a righe e
						senza colore: si modificano dal loro circolo.
					</Text>
					<Div d="flex" flexWrap="wrap" style={{ gap: "0.5rem" }}>
						{others.map(schoolID => {
							const isShown = !hiddenOtherSchools.includes(schoolID)
							return (
								<ToggleChip
									key={schoolID}
									text={schools[schoolID].schoolName}
									isSelected={isShown}
									onClick={() => setOtherSchoolHidden(schoolID, isShown)}
								/>
							)
						})}
					</Div>
				</Div>
			)}
		</>
	)
}

export default OtherSchoolsSelector
